import { Nullable } from "global";
import { DeskingSubmitOptions } from "modules/desking/types";
import { equipmentMileageFormatter } from "../../desking";

export function collectEquipmentDTO(
  equipment: DeskingSubmitOptions["form"]["equipment"]
): Nullable<Record<string, any>> {
  if (!equipment.retailPrice || !equipment.quantity || !equipment.newUsed) {
    return null;
  }

  const { selectedEquipment, class: classType, description: additionalDescription, ...equipmentDTO } = equipment;

  return {
    ...equipmentDTO,
    classType,
    additionalDescription,
    year: equipmentDTO.year.toString(),
    quantity: Number(equipmentDTO.quantity),
    mileage: equipmentMileageFormatter(equipmentDTO.mileage, "toInt"),
  };
}
